import { Permission } from '@/config/permissions'
import { httpClient } from '@/lib/api'

export type TeamRole = 'OWNER' | 'MANAGER' | 'ATTENDANT'

export type Team = {
  id: number
  name: string
  ownerId?: string
  createdAt: string
  updatedAt: string
  deletedAt: string | null
  isOwner?: boolean
  myRole?: TeamRole
  permissions: Permission[] | null
  attendants: unknown[]
}

export class TeamService {
  public static async getTeams() {
    const { data } = await httpClient().get<Team[]>('/team')
    return data
  }

  public static async getPermissions() {
    const { data } = await httpClient().get<Permission[]>('/team/permissions')
    return data
  }

  public static async getAttendantPermissionsConfig() {
    const { data } = await httpClient().get<Permission[]>(
      '/team/permissions/config'
    )
    return data
  }

  public static async updatePermissions(permissions: Permission[]) {
    const { data } = await httpClient().patch<Permission[]>('/team/permissions', {
      permissions,
    })
    return data
  }
}
